import React from "react";

export const MiniMapButton = ({ id, onClick }) => (
    <div className="mini-map-button" onClick={() => onClick(id)}>
        Skatīt lielizmēra karti
    </div>
);
